import { useWorkspace } from '@aibees/shared/workspace';
import { SocketMessageType } from '../types';

export function useGetSocketChannel(type: SocketMessageType) {
  const workspace = useWorkspace();

  switch (type) {
    case SocketMessageType.NOTIFICATION_COUNT:
      return `ws:#${workspace?.user.id}`;
    case SocketMessageType.PERSON_CHANGES:
    case SocketMessageType.COMPANY_CHANGES:
    case SocketMessageType.LABEL_UPDATE:
    case SocketMessageType.BALANCE:
    case SocketMessageType.SUBSCRIPTION:
    case SocketMessageType.EXPORT_ADD:
    case SocketMessageType.EXPORT_UPDATE:
    case SocketMessageType.PAYMENT_METHOD:
      return `ws:#${workspace?.id}`;
    default:
      return 'no channel';
  }
}
